import { render, staticRenderFns } from "./GlobalTitle.vue?vue&type=template&id=257398cf&scoped=true&name=global-title&"
import script from "./GlobalTitle.vue?vue&type=script&lang=js&"
export * from "./GlobalTitle.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTitle.vue?vue&type=style&index=0&id=257398cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257398cf",
  null
  
)

export default component.exports